/** @module ChangeTracking/main */
define([
	"csi/access/crews",
	"csi/locale",
	"csi/state/rootStore",
	"./changeLogService",
	"csi/message",
	"csi/widget/MessageDialog",
	"./ChangeLogTable.js",
	"csi/comm/GetRequest"
], function(crews, locale, {featureTogglesStore}, changeLogService, message, MessageDialog, ChangeLogTable, GetRequest) {
	const REQUEST_MODULE = "ChangeTracking";

	return {
		VALUE_ATTR_CLASS: "SpecificationDataSheetItem",
		VALUE_ATTR: "Value",
		VALUE_ATTRS: ["ValueLookupItem", "ValueLookupItemList", "ValueBoolean", "ValueDouble", "ValueInt", "ValueString"],

		/**
		 * Enable access to ChangeLog only to users who have role Change Log Viewer
		 *
		 * @param {Context} ctx
		 * @param {Tab} defTab
		 * @param {String} rootNodeType
		 * @param {Node} rootNode
		 *
		 * @return {boolean} whether user has access
		 */
		onAccessChangeTracking: function(node, cache) {
			return crews.isInRoles(changeLogService.getTrackingRoles(), node);
		},

		onAccessChangeTrackingConfiguration: function(node, cache) {
			return crews.isInRoles(changeLogService.getConfigRoles(), node);
		},
		
		onAccessCLArchiving: function(node, cache) {
			return featureTogglesStore.ENABLE_CL_ARCHIVING;
		},


		postActionArchiveCL: function (ac) {
			const acStr = ac.m_action.m_id === 'ArchiveChangeLogs'? 'archived' : 'pruned'
			const result = ac.m_response.data.VALUES.Value[0].Value;
			message.showDialog({
				message: `${result} Change Logs entries have been ${acStr}!`,
				title: locale.resource("ArchiveChangeLogs"),
				materialIcon: MessageDialog.ICON_INFO,
				buttons: [MessageDialog.BUTTON_CLOSE],
			});
		},

		/**
		 * Validate that the Excel Export Query Limit does not exceed the Excel Export Total Records Limit.
		 * @param {ActionController} ac
		 * @param {Context} ctx
		 */
		validateChangeLogExcelExportQueryLimit: function(ac, ctx) {
			var node = ctx.getCache().getNode(ac.m_urlNode);
			if (!node || !ac.newValue || !node.ChangeLogExcelExportTotalRecordsLimit) {
				return;
			}

			if (ac.newValue > node.ChangeLogExcelExportTotalRecordsLimit) {
				throw new Error(locale.resource("ChangeLogExcelExportLimitInvalid"));
			}
		},

		/**
		 * Validate that the Excel Export Query Limit does not exceed the Excel Export Total Records Limit.
		 * @param {ActionController} ac
		 * @param {Context} ctx
		 */
		validateChangeLogExcelExportTotalRecordsLimit: function(ac, ctx) {
			var node = ctx.getCache().getNode(ac.m_urlNode);
			if (!node || !ac.newValue || !node.ChangeLogExcelExportQueryLimit) {
				return;
			}

			if (node.ChangeLogExcelExportQueryLimit > ac.newValue) {
				throw new Error(locale.resource("ChangeLogExcelExportLimitInvalid"));
			}
		}
	}
});
